import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { RuntimeProviders } from "./auth/runtime-providers";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Site Administration root element is missing.");
createRoot(rootElement).render(
  <StrictMode>
    <RuntimeProviders>
      <App />
    </RuntimeProviders>
  </StrictMode>,
);
